import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SwiperContainer } from 'swiper/element';

@Directive({
    selector: '[appSwiper]'
})
export class SwiperDirective implements AfterViewInit, OnChanges {
    @Input() shouldLoop: boolean;
    @Input() slideData: any[];

    constructor(private _el: ElementRef<SwiperContainer>, private _changeDetectorRef: ChangeDetectorRef) {}
    
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.slideData && !changes.slideData.isFirstChange()) {
            this.fireEvents();
        }
    }

    public ngAfterViewInit(): void {
        let config = {
            updateOnWindowResize: true,
            navigation: true,
            breakpoints: {
                1: {
                    slidesPerView: 1
                },
                600: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1280: {
                    slidesPerView: 4
                }
            }
        } as any;

        if (this.shouldLoop) {
            this.initializeWithLoop(config);
        }
        else {
            Object.assign(this._el.nativeElement, config);
            this._el.nativeElement.initialize();
        }

        this.fireEvents();
    }

    public initializeWithLoop(config: any): void {
        config = {
            ...config,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true
            },
            loopAddBlankSlides: true
        };

        Object.assign(this._el.nativeElement, config);
        this._el.nativeElement.initialize();
        this._el.nativeElement.swiper.autoplay.start();
    }

    public fireEvents(): void {
        this._changeDetectorRef.detectChanges();
        this._el.nativeElement.swiper.update();
    }
}
